import React, { useEffect, useState } from "react";
import { Button, Tooltip, Collapse, Table } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import _ from "lodash";

import parse from "html-react-parser";
import hostURL from "../../Common/constants";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

//step2 Images
import aquaculture from "../../images/landscape/AquaculturePond.png";
import cropland from "../../images/landscape/Cropland.png";
// import timber from "../../images/landscape/Timber.png";
import pasture from "../../images/landscape/Pasture.png";
import wetland from "../../images/landscape/Wetland.png";

//step3 Images
import aquatic from "../../images/priority/Aquatic.png";
import biggame from "../../images/priority/BigGame.png";
import carbonstorage from "../../images/priority/CarbonStorage.png";
import drought from "../../images/priority/Drought.png";
// import watertemperature from "../../images/priority/WaterTemperature.png";
import excesswind from "../../images/priority/ExcessWind.png";
import flooding from "../../images/priority/Flooding.png";
import forestbirds from "../../images/priority/ForestBirds.png";
import grasslandbirds from "../../images/priority/GrasslandBirds.png";
import pollinators from "../../images/priority/Pollinators.png";
import snowdrift from "../../images/priority/SnowDrift.png";
import soilhealth from "../../images/priority/SoilHealth.png";
import watererosion from "../../images/priority/WaterErosion.png";
import waterfowl from "../../images/priority/Waterfowl.png";
import waterquality from "../../images/priority/WaterQuality.png";
import winderosion from "../../images/priority/WindErosion.png";
import priorityecosystem from "../../images/priority/PriorityEcosystem.png";

import practiceImages from "../../utils/practiceImages";

import "./style.css";
import TablePractice from "./Components/Table";

import { LuPrinter } from "react-icons/lu";
import { useSelector } from "react-redux";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Practice = ({ practiceNumber }) => {
  const Panel = Collapse.Panel;
  const [selectedPracticeData, setSelectedPracticeData] = useState(false);
  const [allPracticesData, setAllPracticesData] = useState(null);
  const pathNames = window.location.pathname?.split("/") ?? [];

  const getDecoded = (index) => {
    const value = pathNames[index];
    return value ? atob(value).trim() : null;
  };

  let pdfLink = getDecoded(3)?.replace(/"/g, "") ?? null;
  const prTitle = getDecoded(4) ?? "";
  const prCode = prTitle.split("-")[0]?.trim() ?? "";
  const prName = prTitle.split(/-(.*)/)[1]?.trim() ?? null;
  const crepName = getDecoded(5);

  const [activeKey, setActiveKey] = useState([]);
  const [isAccordion, setIsAccordion] = useState(true);
  const [selStateCrepData, setSelStateCrepData] = useState(null);
  const [isCrepDetails, setIsCrepDetails] = useState(false);
  const [crepDetTableData, setCrepDetTableData] = useState(null);
  const selectedState = useSelector((state) => state.filter.selectedState);
  const hydrated = useSelector((state) => state.filter.hydrated);

  // FOR PDF VIEWER
  const [numPages, setNumPages] = useState(null);
  const [pdfContainerWidth, setPdfContainerWidth] = useState(900);
  const pdfWrapRef = React.useRef(null);

  const isTouch =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // Use iframe only on non-touch, desktop-ish widths
  const useIframe = !isTouch && !isIOS && windowWidth >= 1200; // bump threshold to be safe

  const onPdfLoadSuccess = ({ numPages }) => setNumPages(numPages);

  useEffect(() => {
    const measure = () => {
      if (pdfWrapRef.current) {
        // Keep a max so huge screens don’t blow it up
        setPdfContainerWidth(Math.min(pdfWrapRef.current.clientWidth, 1000));
      }
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  // const parseIncentive = (incentive) => {
  //   if (!incentive || typeof incentive !== "string") return Object.create(null);
  //   try {
  //     return JSON.parse(incentive.replaceAll("‘", '"').replaceAll("’", '"'));
  //   } catch {
  //     return Object.create(null);
  //   }
  // };
  useEffect(() => {
    if (!hydrated) return;
    (async () => {
      await fetch(
        `${hostURL}api/natpractices/${prCode}/${encodeURIComponent(prName)}`
      )
        .then((response) => response.json())
        .then((json) => {
          setSelectedPracticeData(json);
        })
        .catch((error) => console.error(error));

      await fetch(`${hostURL}api/natpractices`)
        .then((response) => response.json())
        .then((json) => {
          setAllPracticesData(json);
        })
        .catch((error) => console.error(error));
      if (crepName && selectedState)
        await fetch(
          `${hostURL}api/creppractices/${prCode}/${encodeURIComponent(
            selectedState
          )}/${encodeURIComponent(crepName)}`
        )
          .then((response) => response.json())
          .then((json) => {
            setCrepDetTableData(json[0]);
            console.log("JSON DATA: ", json);
            setIsCrepDetails(true);
          })
          .catch((error) => console.error(error));
    })();
  }, [hydrated, selectedState]);

  const printing = () => {
    window.print();
    setActiveKey([]);
    setIsAccordion(true);
  };

  const handlePrint = () => {
    showAll();
    setTimeout(printing, 500);
  };

  const showAll = () => {
    setIsAccordion(false);
    setActiveKey([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  };

  const handleCollapseOpen = (key) => {
    if (key === activeKey) setActiveKey(0);
    else setActiveKey(key);
  };

  const newPracticeData = {
    id: selectedPracticeData.id,
    name: selectedPracticeData.pname,
    description: selectedPracticeData.descriptn,
    programs: [
      {
        name: prTitle.toLowerCase().includes("cp88")
          ? "Grassland CRP Signup"
          : "General Signup",
        period: selectedPracticeData.cntrctpd,
        incentives: {
          //climateSmart: selectedPracticeData.climate_smrt_incentive,
          sip: selectedPracticeData["32_5_p_sip"],
          pip: selectedPracticeData["50_p_pip"],
          rentalRateIncentive: false,
          rentalRateAdj: false,
        },
      },
      {
        name: "Continuous Signup",
        period: selectedPracticeData.cntrctprdthrucontinous,
        incentives: {
          //climateSmart: selectedPracticeData.climatesmartincentivethrucontinous,
          sip: selectedPracticeData.sipthrucontinous !== "false",
          pip: selectedPracticeData.pipthrucontinous !== "false",
          rentalRateIncentive:
            selectedPracticeData.rentalrateincentivethrucontinuous !== "false",
          rentalRateAdj: false,
        },
      },
      {
        name: "HELI",
        period: selectedPracticeData.cntrctprdthruheli,
        incentives: {
          // climateSmart: selectedPracticeData.climatesmartincentivethruheli,
          sip: selectedPracticeData.sipthruheli !== "false",
          pip: selectedPracticeData.pipthruheli !== "false",
          rentalRateIncentive: false,
          rentalRateAdj: false,
        },
      },
      {
        name: "Wellhead Protection",
        period: selectedPracticeData.cntrctprdthruwellhead,
        incentives: {
          // climateSmart: selectedPracticeData.climatesmartincentivethruwellhead,
          sip: selectedPracticeData.sipthruwellhead !== "false",
          pip: selectedPracticeData.pipthruwellhead !== "false",
          rentalRateIncentive: false,
          rentalRateAdj: false,
        },
      },
      {
        name: "Farmable Wetland Program",
        period: selectedPracticeData.cntrctprdthrufwp,
        incentives: {
          // climateSmart: selectedPracticeData.climatesmartincentivethrufwp,
          sip: selectedPracticeData.sipthrufwp !== "false",
          pip: selectedPracticeData.pipthrufwp !== "false",
          rentalRateIncentive: false,
          rentalRateAdj: selectedPracticeData.rentalrateadjthrufwp !== "false",
        },
      },
      {
        name: "SAFE",
        period: selectedPracticeData.cntrctprdthrusafe,
        incentives: {
          // climateSmart: selectedPracticeData.climatesmartincentivethrusafe,
          sip: selectedPracticeData.sipthrusafe !== "false",
          pip: selectedPracticeData.pipthrusafe !== "false",
          rentalRateIncentive:
            selectedPracticeData.rentalrateincentivesafe !== "false",
          rentalRateAdj: false,
        },
      },
      {
        name: "CLEAR30",
        period: selectedPracticeData.cntrctprdthruclear30,
        incentives: {
          // climateSmart: selectedPracticeData.climatesmartincentivethruclear30,
          sip: selectedPracticeData.sipthruclear30 !== "false",
          pip: selectedPracticeData.pipthruclear30 !== "false",
          rentalRateIncentive: false,
          rentalRateAdj:
            selectedPracticeData.rentalrateadjthruclear30 !== "false",
          waterqualitythruclear30:
            selectedPracticeData.waterqualitythruclear30 !== "false",
        },
      },
    ],
    priorities: [
      {
        name: "Wind Erosion",
        eligible: selectedPracticeData.winderosion,
        imgSrc: winderosion,
      },
      {
        name: "Water Erosion",
        eligible: selectedPracticeData.watererosion,
        imgSrc: watererosion,
      },
      {
        name: "Soil Health",
        eligible: selectedPracticeData.soilhealth,
        imgSrc: soilhealth,
      },
      {
        name: "Excess Wind",
        eligible: selectedPracticeData.excesswind,
        imgSrc: excesswind,
      },
      {
        name: "Drought",
        eligible: selectedPracticeData.drought,
        imgSrc: drought,
      },
      // {
      //   name: "Water Temperature",
      //   eligible: selectedPracticeData.elevatedwatertemperature,
      //   imgSrc: watertemperature,
      // },
      {
        name: "Flooding",
        eligible: selectedPracticeData.flooding,
        imgSrc: flooding,
      },
      {
        name: "Snow Drift",
        eligible: selectedPracticeData.snowdrift,
        imgSrc: snowdrift,
      },
      {
        name: "Water Quality",
        eligible: selectedPracticeData.waterquality,
        imgSrc: waterquality,
      },
      {
        name: "Aquatic",
        eligible: selectedPracticeData.aquatic,
        imgSrc: aquatic,
      },
      {
        name: "Big Game",
        eligible: selectedPracticeData.biggame,
        imgSrc: biggame,
      },
      {
        name: "Grassland Animals",
        eligible: selectedPracticeData.grasslandbirds,
        imgSrc: grasslandbirds,
      },
      {
        name: "Forest Animals",
        eligible: selectedPracticeData.forestbirds,
        imgSrc: forestbirds,
      },
      {
        name: "Pollinators",
        eligible: selectedPracticeData.pollinators,
        imgSrc: pollinators,
      },
      {
        name: "Waterfowl",
        eligible: selectedPracticeData.waterfowl,
        imgSrc: waterfowl,
      },
      {
        name: "Carbon Storage",
        eligible: selectedPracticeData.carbonstorage,
        imgSrc: carbonstorage,
      },
      {
        name: "Ecosystem",
        eligible: selectedPracticeData.priorityecosystem,
        imgSrc: priorityecosystem,
      },
      {
        name: "Aquaculture Ponds",
        eligible: selectedPracticeData.aquaculture,
        imgSrc: aquaculture,
      },
      {
        name: "Cropland",
        eligible: selectedPracticeData.cropland,
        imgSrc: cropland,
      },
      // { name: "Timber", eligible: selectedPracticeData.timber, imgSrc: timber },
      {
        name: "Pasture",
        eligible: selectedPracticeData.pasture,
        imgSrc: pasture,
      },
      {
        name: "Wetland",
        eligible: selectedPracticeData.wetland,
        imgSrc: wetland,
      },
    ],
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const scrollTimeout = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 300);

    return () => clearTimeout(scrollTimeout);
  }, []);

  const sortedData = (data) => {
    return data.sort((a, b) => {
      const numA = parseInt(a.Practice.match(/\d+/)[0]);
      const numB = parseInt(b.Practice.match(/\d+/)[0]);
      return numA - numB;
    });
  };

  const getPracticeNum = (text) => {
    const match = text.match(/(cp\d+[a-z]?)/i);
    return match ? match[1].toUpperCase() : null;
  };
  const getPracticeObjNP = (pnumber) => {
    var toReturn = allPracticesData.find((obj) => obj.pnumber === pnumber);
    return toReturn;
  };

  const hasKeyInData = (dataset, key) =>
    _.some(dataset, (item) => _.has(item, key));

  const AntdTable = (tableData) => {
    const parseIncentive = (incentiveStr) => {
      try {
        console.log(incentiveStr);
        const safeStr = incentiveStr?.replace(/[‘’]/g, "'").replace(/'/g, '"');
        return JSON.parse(safeStr);
      } catch (e) {
        console.warn("Invalid JSON:", e);
        return {};
      }
    };

    const formatTitleFromKey = (key) => {
      const parts = key.split("_");

      const firstPart = parts[0];
      const isNumber = !isNaN(firstPart);

      const percent = isNumber ? firstPart + "%" : firstPart;

      const suffix = parts[parts.length - 1];
      let label = percent;

      if (suffix === "sip") {
        const percentage = parseFloat(parts[0]) + parseFloat(parts[1]) / 10;
        const formattedLabel = percentage + "%";
        label =
          label !== "sip"
            ? formattedLabel + " Signup Incentive Payment (SIP)"
            : "$100/acre SIP";
      } else if (suffix === "pip") {
        label += " Practice Incentive Payment (PIP)";
      } else {
        label += " Incentive";
      }

      return label;
    };

    const renderEligibilityIcon = (value) => (
      <Tooltip placement="topLeft" title={value ? "Eligible" : "Not Eligible"}>
        {value ? (
          <CheckCircleOutlined style={{ color: "green" }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red" }} />
        )}
      </Tooltip>
    );

    const getIncentiveRows = (dataSource) => {
      console.log("DATA SOURCE: ", dataSource);
      if (!dataSource || dataSource.length === 0) {
        console.error("No data available to map incentives.");
        return [];
      }

      const row = dataSource;
      const allIncentives = {
        ...parseIncentive(row.crepincentive1),
        ...parseIncentive(row.crepincentive2),
      };

      const newEnrollmentRate = row.newenrollmentsrr || "N/A";

      const incentiveRows = Object.entries(allIncentives).map(
        ([key, value]) => ({
          key,
          incentive: formatTitleFromKey(key),
          value: renderEligibilityIcon(value),
        })
      );
      incentiveRows.push({
        key: "new_enrollment_rate",
        incentive: "Additional Rental Rate for New Enrollments",
        value: newEnrollmentRate + "%",
      });

      const stateIncentive = row.stateincentive || "0.00";
      incentiveRows.push({
        key: "stateincentive",
        incentive: "Additional State Incentive Per Acre",
        value: "$" + stateIncentive,
      });

      const contractLength = row.contractlength || "-";
      incentiveRows.unshift({
        key: "contractlength",
        incentive: "Contract Period",
        value: contractLength + " Years",
      });

      return incentiveRows;
    };

    const incentiveRows = getIncentiveRows(tableData).filter(
      (row) =>
        row &&
        Object.keys(row).length > 0 &&
        row.incentive?.toString().trim() !== "" &&
        row.value?.toString().trim() !== ""
    );

    const columns = [
      {
        title: "",
        dataIndex: "incentive",
        key: "incentive",
      },
      {
        title: `${crepName} - ${prCode}`,
        dataIndex: "value",
        key: "value",
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={incentiveRows}
        pagination={false}
        rowKey="key"
        className="crepDetailsColumn"
      />
    );
  };

  pdfLink = crepName ? crepDetTableData?.pdflink : pdfLink;
  return (
    <>
      <Header />
      <Button
        onClick={() => handlePrint()}
        className="report-print-button details-print-button"
      >
        <LuPrinter className="report-button-icon" /> Print
      </Button>

      {selectedPracticeData && (
        <div className="practice-page">
          <h3>
            <u>{isCrepDetails ? crepName : prTitle?.toUpperCase()}</u>
          </h3>
          {practiceImages[selectedPracticeData.pnumber] && (
            <img
              alt={`how ${selectedPracticeData.pnumber} could look after implementation`}
              className="practice-image"
              src={practiceImages[selectedPracticeData.pnumber]}
              style={{ width: "100%" }}
            />
          )}
          {selectedPracticeData.descriptn && (
            <>
              <h4>Description:</h4> <p>{isCrepDetails && crepDetTableData ? crepDetTableData.description : selectedPracticeData.descriptn}</p>
            </>
          )}
          
          {atob(window.location?.pathname?.split("/")[4] || "").startsWith(
            "CP21"
          ) && (
            <>
              <p>
                Ask your local FSA agent for details about CP21S - Saturated
                Filter Strips and CP21B - Denitrifying Bioreactor on Filter
                Strips.
              </p>
            </>
          )}
          {atob(window.location?.pathname?.split("/")[4] || "").startsWith(
            "CP22"
          ) && (
            <>
              <p>
                Ask your local FSA agent for details about CP22S - Saturated
                Riparian Buffer and CP22B - Denitrifying Bioreactor on Riparian
                Buffer.
              </p>
            </>
          )}
          {!isCrepDetails && newPracticeData && (
            <>
          <h4>Related Priorities:</h4>
   
            <div>
              <p className="step3_images">
                {newPracticeData.priorities.map((priority) => {
                  return (
                    priority.eligible && (
                      <Tooltip placement="topLeft" title={priority.name}>
                        <img
                          alt={`line art logo that represents ${priority.name}`}
                          className="img_selected_cb"
                          src={priority.imgSrc}
                        />
                      </Tooltip>
                    )
                  );
                })}
              </p>
            </div>
            </>
              )}

          {isCrepDetails ? (
            <>{AntdTable(crepDetTableData)}</>
          ) : (
            <TablePractice newPracticeData={newPracticeData} />
          )}

          {!isCrepDetails && (
            <p>
              This practice is not eligible for enrollment through:&nbsp;
              {newPracticeData.programs
                .filter((program) => program.period === "false")
                .map((program, index, arr) => {
                  if (index === arr.length - 1 && arr.length > 1) {
                    return ` or ${program.name}`;
                  }
                  return program.name;
                })
                .join(", ")
                .replace(/,(\s*or)/, "$1")}
              . SIP and PIP are one-time incentive payments. Rental Rate and
              Water Quality Incentives are recurring incentives received
              annually throughout the contract.
            </p>
          )}

          { !isCrepDetails &&
            <div className="cost-maint-manage">
              <Collapse
                header=""
                accordion={isAccordion}
                className="mt-3 crp-basics-paragraph"
                activeKey={activeKey}
              >
                {selectedPracticeData.costshareavble && (
                  <Panel
                    onClick={() => {
                      handleCollapseOpen(1);
                    }}
                    header="Cost share available for"
                    key="1"
                  >
                    {parse(selectedPracticeData.costshareavble)}
                    {isCrepDetails && (
                      <>
                        {" "}
                        <strong>
                          Meet with your local FSA agent or technical service
                          provider for more details on CREP.
                        </strong>
                        <br />
                        <br />
                      </>
                    )}
                  </Panel>
                )}

                {selectedPracticeData.maintenance && (
                  <Panel
                    onClick={() => {
                      handleCollapseOpen(3);
                    }}
                    header="Maintenance"
                    key="3"
                  >
                    {parse(selectedPracticeData.maintenance)}
                    {isCrepDetails && (
                      <>
                        {" "}
                        <strong>
                          Meet with your local FSA agent or technical service
                          provider for more details on CREP.
                        </strong>
                      </>
                    )}
                  </Panel>
                )}
                {!isCrepDetails &&
                  selectedPracticeData.maintenanceforclear30 && (
                    <Panel
                      onClick={() => {
                        handleCollapseOpen(4);
                      }}
                      header="Maintenance for Clear30"
                      key="4"
                    >
                      {parse(selectedPracticeData.maintenanceforclear30)}
                      {isCrepDetails && (
                        <>
                          {" "}
                          <strong>
                            Meet with your local FSA agent or technical service
                            provider for more details on CREP.
                          </strong>
                        </>
                      )}
                    </Panel>
                  )}
                {selectedPracticeData.management && (
                  <Panel
                    onClick={() => {
                      handleCollapseOpen(5);
                    }}
                    header="Management"
                    key="5"
                  >
                    {parse(selectedPracticeData.management)}
                    {isCrepDetails && (
                      <>
                        {" "}
                        <strong>
                          Meet with your local FSA agent or technical service
                          provider for more details on CREP.
                        </strong>
                      </>
                    )}
                  </Panel>
                )}
                {!isCrepDetails && selectedPracticeData.eligibilityforheli && (
                  <Panel
                    onClick={() => {
                      handleCollapseOpen(6);
                    }}
                    header="Eligibility for Heli"
                    key="6"
                  >
                    {parse(selectedPracticeData.eligibilityforheli)}
                  </Panel>
                )}
                {!isCrepDetails &&
                  selectedPracticeData.eligiblityforwellhead && (
                    <Panel
                      onClick={() => {
                        handleCollapseOpen(7);
                      }}
                      header="Eligibility for Wellhead Protection"
                      key="7"
                    >
                      {parse(selectedPracticeData.eligiblityforwellhead)}
                    </Panel>
                  )}
                {!isCrepDetails &&
                  selectedPracticeData.eligiblitythrucontinuous && (
                    <Panel
                      onClick={() => {
                        handleCollapseOpen(8);
                      }}
                      header="Eligibility through Continuous"
                      key="8"
                    >
                      {parse(selectedPracticeData.eligiblitythrucontinuous)}
                    </Panel>
                  )}
                {!isCrepDetails &&
                  selectedPracticeData.eligiblitythruclear30 && (
                    <Panel
                      onClick={() => {
                        handleCollapseOpen(9);
                      }}
                      header="Eligibility through Clear30"
                      key="9"
                    >
                      {parse(selectedPracticeData.eligiblitythruclear30)}
                    </Panel>
                  )}
                {!isCrepDetails && selectedPracticeData.eligiblitythrufwp && (
                  <Panel
                    onClick={() => {
                      handleCollapseOpen(10);
                    }}
                    header="Eligibility through FWP"
                    key="10"
                  >
                    {parse(selectedPracticeData.eligiblitythrufwp)}
                  </Panel>
                )}
                {!isCrepDetails && selectedPracticeData.eligibilitythrugrassland && (
                  <Panel
                    onClick={() => {
                      handleCollapseOpen(10);
                    }}
                    header="Eligibility through Grassland"
                    key="10"
                  >
                    {parse(selectedPracticeData.eligibilitythrugrassland)}
                  </Panel>
                )}
                {isCrepDetails && (
                  <Panel
                    onClick={() => {
                      handleCollapseOpen(11);
                    }}
                    header="Eligibility through CREP"
                    key="11"
                  >
                    {crepDetTableData &&
                      parse(crepDetTableData.crepdetailsdata)}
                    {isCrepDetails && (
                      <>
                        {" "}
                        <strong>
                          Meet with your local FSA agent or technical service
                          provider for more details on CREP.
                        </strong>
                      </>
                    )}
                  </Panel>
                )}
              </Collapse>
              <br />
            </div>
          }

          {pdfLink !== "false" && (
            <>
              <hr className="my-4" />
              <h4>
                <u>{isCrepDetails ? crepName : prTitle}</u>
              </h4>

              {/* Use iframe on desktop; React-PDF on tablets/phones */}
              {useIframe ? (
                <div className="embed-responsive">
                  <iframe
                    title={prTitle}
                    className="embed-responsive-item"
                    src={`/Practices/${pdfLink}`}
                    allow="fullscreen"
                  />
                </div>
              ) : (
                <>
                  <div ref={pdfWrapRef} className="pdf-scroll">
                    <Document
                      file={`/Practices/${pdfLink}`}
                      onLoadSuccess={onPdfLoadSuccess}
                      loading={<p style={{ padding: 12 }}>Loading PDF…</p>}
                      error={
                        <p style={{ padding: 12, color: "crimson" }}>
                          Failed to load PDF.
                        </p>
                      }
                    >
                      {Array.from(new Array(numPages || 0), (el, index) => (
                        <Page
                          key={`page_${index + 1}`}
                          pageNumber={index + 1}
                          width={pdfContainerWidth}
                          className="pdf-page"
                          renderTextLayer={false}
                          renderAnnotationLayer={false}
                        />
                      ))}
                    </Document>
                  </div>

                  {/* Always give a direct link as a fallback on mobile */}
                  <p style={{ marginTop: 12 }}>
                    Having trouble?{" "}
                    <a
                      className="pdf-link"
                      href={`/Practices/${pdfLink}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Open the USDA Fact Sheet
                    </a>
                  </p>
                </>
              )}
            </>
          )}
        </div>
      )}
      <>
        <p className="practice-page">
          For more information on practice details, please visit{" "}
          <a
            className="externel-link"
            href="https://efotg.sc.egov.usda.gov/#/"
            target="_blank"
          >
            <u>Field Office Technical Guide | NRCS - USDA.</u>
          </a>
        </p>
      </>

      <Footer />
    </>
  );
};

export default Practice;
